/* Consent-gated analytics & marketing pixel loader.
 * Providers: GA4, Google Tag Manager, Meta Pixel, TikTok Pixel, Microsoft Clarity.
 * Scripts are injected only after the relevant consent category is granted.
 * All tracking helpers are no-ops when a provider isn't loaded.
 */

const loaded = { ga4: false, gtm: false, meta: false, tiktok: false, clarity: false };

export function loadGA4(id) {
  if (loaded.ga4 || !id) return;
  loaded.ga4 = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { send_page_view: false });
}

export function loadGTM(id) {
  if (loaded.gtm || !id) return;
  loaded.gtm = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  document.head.appendChild(s);
}

export function loadMetaPixel(id) {
  if (loaded.meta || !id) return;
  loaded.meta = true;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", id);
  window.fbq("track", "PageView");
}

export function loadTikTok(id) {
  if (loaded.tiktok || !id) return;
  loaded.tiktok = true;
  /* eslint-disable */
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = (w[t] = w[t] || []);
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
    ttq.setAndDefer = function (e, n) {
      e[n] = function () { e.push([n].concat(Array.prototype.slice.call(arguments, 0))); };
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (e) {
      for (var n = ttq._i[e] || [], r = 0; r < ttq.methods.length; r++) ttq.setAndDefer(n, ttq.methods[r]);
      return n;
    };
    ttq.load = function (e, n) {
      var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r;
      ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
      ttq._o = ttq._o || {}; ttq._o[e] = n || {};
      var o = d.createElement("script");
      o.type = "text/javascript"; o.async = !0;
      o.src = r + "?sdkid=" + e + "&lib=" + t;
      var a = d.getElementsByTagName("script")[0];
      a.parentNode.insertBefore(o, a);
    };
    ttq.load(id);
    ttq.page();
  })(window, document, "ttq");
  /* eslint-enable */
}

export function loadClarity(id) {
  if (loaded.clarity || !id) return;
  loaded.clarity = true;
  /* eslint-disable */
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", id);
  /* eslint-enable */
}

/* Load the right providers based on the visitor's consent choices. */
export function applyConsent(settings, consent) {
  if (!settings || !consent) return;
  const a = settings.analytics || {};
  if (consent.analytics) {
    loadGA4(a.ga4_id);
    loadGTM(a.gtm_id);
    loadClarity(a.clarity_id);
  }
  if (consent.marketing) {
    loadMetaPixel(a.meta_pixel_id);
    loadTikTok(a.tiktok_pixel_id);
  }
}

export function trackEvent(name, params = {}) {
  try {
    if (window.gtag) window.gtag("event", name, params);
    if (window.dataLayer) window.dataLayer.push({ event: name, ...params });
    if (window.fbq) window.fbq("trackCustom", name, params);
    if (window.ttq && typeof window.ttq.track === "function") window.ttq.track(name, params);
  } catch (e) {
    /* swallow — analytics must never break UX */
  }
}

export function trackPageView(path) {
  try {
    if (window.gtag) window.gtag("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
    if (window.fbq) window.fbq("track", "PageView");
    if (window.ttq && typeof window.ttq.page === "function") window.ttq.page();
  } catch (e) {
    /* no-op */
  }
}
